import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import {
  ErrorDetails,
  DriverStatusResponseDTO
} from '../../interfaces/apiInterfaces';

export class GetDriverStateCommand extends IRequestCommand<
  IGetDriverStatusResponse,
  ErrorDetails,
  IGetDriverStateCommandParameters
> {

  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl =
    'carriers/{carrierUserId}/drivers/{driverId}/status';
  constructor() {
    super();
  }

  public override setParameters(parameters: IGetDriverStateCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId
    );

    this._commandUrl = this._commandUrl.replace(
      '{driverId}',
      parameters.driverId
    );
  }
}

export interface IGetDriverStateCommandParameters
  extends ICommandParameters {
  carrierUserId: string,
  driverId: string
}

export interface IGetDriverStatusResponse extends DriverStatusResponseDTO, ICommandResponse { }
